import { render, staticRenderFns } from "./DocumentAnnotationViewer.vue?vue&type=template&id=09fd4202&"
import script from "./DocumentAnnotationViewer.vue?vue&type=script&lang=js&"
export * from "./DocumentAnnotationViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports